import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-71e92eae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "fiscal-code",
  id: "button-content"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "p-2 fiscal-code-search-input-style"
};
const _hoisted_5 = {
  class: "drop-downn-items"
};
const _hoisted_6 = {
  class: "fiscal-dropdown-items"
};
const _hoisted_7 = {
  class: "item-content"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fiscal-dropdown-items"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "item-content"
}, "Product tax code not found")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_b_dropdown, {
    class: "custom-dropdown",
    disabled: $props.disabled,
    variant: "",
    style: {
      "width": "224px"
    },
    ref: "dropdown",
    show: $data.isDropdownOpen,
    "auto-close": "outside",
    "no-caret": "",
    boundary: "window",
    onShow: $options.hideButtonContent,
    onHide: $options.showButtonContent
  }, {
    "button-content": _withCtx(() => [!$data.isSearchActive ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$data.computedValue?.text ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createTextVNode(_toDisplayString($data.computedValue.text) + " ", 1), _createVNode(_component_app_icon, {
      icon: "caret-down-fill-custom",
      class: "placeholder-icon",
      color: "#71777F"
    })])) : (_openBlock(), _createElementBlock("span", _hoisted_3, [_createTextVNode(_toDisplayString($props.placeholder) + " ", 1), _createVNode(_component_app_icon, {
      icon: "caret-down-fill-custom",
      class: "placeholder-icon",
      color: "#71777F"
    })]))])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_b_form_input, {
      modelValue: $data.searchQuery,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchQuery = $event),
      placeholder: "Search...",
      ref: "searchInput",
      size: "sm",
      onFocus: $options.keepDropdownOpen,
      onBlur: $options.handleInputBlur,
      class: _normalizeClass({
        'custom-input': true
      }),
      style: {
        "width": "232px"
      }
    }, null, 8, ["modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredOptions, (option, index) => {
      return _openBlock(), _createBlock(_component_b_dropdown_item, {
        key: index,
        onClick: $event => $options.selectOption(option),
        class: "dropdown-item"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(option.text), 1)])]),
        _: 2
      }, 1032, ["onClick"]);
    }), 128)), $options.filteredOptions.length === 0 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 0,
      disabled: ""
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["disabled", "show", "onShow", "onHide"])]);
}